
import axios from 'axios';
import { debounce } from 'lodash';
import { mapActions } from 'vuex';
import SearchIcon from '../icons/SearchIcon.vue';
import klipyPoweredLogo from '~/assets/img/powered-by-klipy-image.png';

export default {
  name: 'GifSelectorModal',
  components: { SearchIcon },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      apiKey: process.env.NUXT_ENV_KLIPY_API_KEY,
      apiUrl: process.env.NUXT_ENV_KLIPY_API_URL,
      searchText: '',
      loading: false,
      result: [],
      col1: [],
      col2: [],
      col3: [],
      klipyPoweredLogo: klipyPoweredLogo.default || klipyPoweredLogo,
    };
  },

  watch: {
    show: {
      immediate: true,
      async handler(val) {
        if (!val) return;
        if (this.result.length) return;

        this.loading = true;
        await this.searchGifs('trending');
        this.setKlipyLastTrendingSearch();

        document.body.style.overflow = val ? 'hidden' : '';
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      const comp = this.$refs.gifSelectorModalSearchInput;
      // FormulateInput is a component, so getting the real input
      const el = comp?.$el?.querySelector(
        'input, textarea, [contenteditable="true"]'
      );
      el?.focus();
    });
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    ...mapActions('modals', ['setKlipyLastTrendingSearch']),
    performSearch: debounce(function () {
      this.searchGifs(this.searchText ? 'search' : 'trending');
    }, 400),
    async searchGifs(action = 'search') {
      this.result = [];
      this.loading = true;

      try {
        const endpoint =
          action === 'trending'
            ? `${this.apiUrl}/${this.apiKey}/gifs/trending`
            : `${this.apiUrl}/${this.apiKey}/gifs/search`;

        const params =
          action === 'search'
            ? { q: this.searchText, limit: 30 }
            : { page: 1, per_page: 30, customer_id: '12346', locale: 'en-US' };

        const response = await axios.get(endpoint, { params });

        const gifs = response.data?.data?.data ?? [];

        if (!Array.isArray(gifs)) {
          console.error('Unexpected Klipy response:', response.data);
          this.loading = false;
          return;
        }

        const mapped = gifs
          .map((gif) => ({
            id: gif.id,
            url:
              gif.file?.md?.gif?.url ||
              gif.file?.sm?.gif?.url ||
              gif.file?.xs?.gif?.url,
          }))
          .filter((gif) => gif.url);

        this.result = mapped;
        this.distributeIntoColumns(mapped);
      } catch (err) {
        console.error('Klipy search error:', err);
      } finally {
        this.loading = false;
      }
    },

    distributeIntoColumns(items) {
      this.col1 = [];
      this.col2 = [];
      this.col3 = [];

      items.forEach((item, index) => {
        const mod = index % 3;
        if (mod === 0) this.col1.push(item);
        else if (mod === 1) this.col2.push(item);
        else this.col3.push(item);
      });
    },

    onClickImage(image, id, uri) {
      this.$emit('onGifSelected', {
        src: image.target.currentSrc,
        id,
        uri,
      });
      this.closeGifSelectorModal();
    },

    closeGifSelectorModal() {
      this.$emit('close');
      document.body.style.overflow = '';
    },
  },
};
